module.exports = __webpack_public_path__ + "img/img01.3533f812.png";